import * as React from 'react';

import { LoginPageLayout } from './components/LoginPageLayout';

export function LoginPage() {

  return (
    <>
      <LoginPageLayout />
    </>
  );
}
